import { useAtomValue } from 'jotai';
import { createdSubtractGeometryLoadableAtom } from './atoms';
import { PolygonArea } from 'components/map';
import { buildPolygonStyle } from 'lib/map';

export const SubtractPolygon = () => {
  const subtractGeometryLoadable = useAtomValue(
    createdSubtractGeometryLoadableAtom
  );
  const geometry =
    subtractGeometryLoadable.state === 'hasData'
      ? subtractGeometryLoadable.data?.geojson
      : null;

  return geometry ? (
    <PolygonArea
      key="subtract-geometry-asb"
      id="subtract-geometry-asb"
      geometry={geometry}
      style={buildPolygonStyle({
        color: '#FFFF00',
        fillOpacity: 0,
        lineOpacity: 1,
        lineWidth: 2,
      })}
    />
  ) : null;
};
